import { render, staticRenderFns } from "./CompraForm.vue?vue&type=template&id=54021992&scoped=true"
import script from "./CompraForm.vue?vue&type=script&lang=js"
export * from "./CompraForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54021992",
  null
  
)

export default component.exports